import React, { useEffect, useState } from "react";

import "./RecordsFilter.scss";
import Button from "../../../atoms/Button/Button";
import useApi from "../../../hooks/useApi";
import API from "../../../services/rest/api";

const SKELETON_CHIPS = [1, 2, 3, 4, 5];

interface Props {
  selected: string;
  onChange: (recordType: string) => void;
}

const RecordsFilter: React.FC<Props> = ({ selected, onChange }) => {
  const [recordTypes, setRecordTypes] = useState<any>([]);

  const {
    mutate: getRecordTypes,
    isLoading,
    response: getRecordsResponse,
    error: getRecordsError,
  } = useApi(API.GetRecordTypes);

  useEffect(() => {
    getRecordTypes();
  }, []);

  useEffect(() => {
    if (getRecordsResponse && Number(getRecordsResponse.code || 0) === 1) {
      setRecordTypes(getRecordsResponse.data);
    } else if (getRecordsError) {
      console.error("Error fetching record types: ", getRecordsError);
    }
  }, [getRecordsResponse, getRecordsError]);

  if (isLoading) {
    return (
      <div className="record-type-chips">
        {SKELETON_CHIPS.map((chip) => (
          <div className="record-chip-skeleton" key={chip} />
        ))}
      </div>
    );
  }

  // A chip is the shared button in miniature: outlined when idle, filled once
  // chosen.
  const chipProps = (value: string) =>
    ({
      className: "btn-chip",
      variant: selected === value ? "contained" : "outlined",
      onClick: () => onChange(value),
    }) as const;

  return (
    <div className="record-type-chips">
      <Button {...chipProps("")}>All</Button>
      {recordTypes?.map((type: any) => (
        <Button key={type?.test_name} {...chipProps(type?.test_name)}>
          {type?.test_name}
        </Button>
      ))}
    </div>
  );
};

export default RecordsFilter;
